import styled from '@emotion/styled'

export const Name = styled.span`
  margin-left: .5rem;
`

export const OrganizationName = styled.span`
  opacity: ${props => props.disabled ? 0.5 : 1};
`
